export default {
  // 报价管理
  quotationManagement: {
    title: '报价管理',
    description: '管理客户报价和报价流程',

    // 标签页
    tabs: {
      fcl: '整箱报价',
      lcl: '拼箱报价',
      air: '空运报价',
      precarriage: '港前报价',
      oncarriage: '尾程报价'
    },
    status: {
      success: '导入成功',
      failed: '导入失败',
      pending: '待报价',
      quoted: '已报价',
      notEnabled: '无需报价',
      rejected: '拒绝报价',
      unlimited: '无限制'
    },
    labels: {
      importStats: '导入详情',
      successCount: '成功数量',
      failedCount: '失败数量',
      priceNo: '运价编码',
      route: '路线',
      validity: '有效期',
      surchargeResult: '附加费处理结果',
      updated: '已更新',
      added: '已新增',
      overwrite: '覆盖更新',
      addNew: '新增写入',
      origin: '起运港',
      destination: '目的港',
      oceanSurcharge: '海运附加费',
      originSurcharge: '起运港附加费',
      destinationSurcharge: '目的港附加费'
    },

    // 工具栏按钮
    toolbar: {
      addQuotation: '新增报价',
      addFclQuotation: '新增整箱报价',
      addPrePortQuotation: '新增港前报价',
      addLastMileQuotation: '新增尾程报价',
      batchOperations: '批量操作 ({count})',
      batchExport: '批量导出',
      batchExportExcel: '批量导出Excel',
      batchExportCsv: '批量导出CSV',
      batchDelete: '批量删除'
    },

    // 表格列标题
    columns: {
      quotationNo: '报价编号',
      inquiryNo: '询价编号',
      source: '报价来源',
      quoterId: '报价人',
      inquiryCreatedBy: '询价人',
      inquirySubmitDate: '询价时间',
      quotationStatus: '报价状态',
      supplierName: '供应商',
      selection: '选择',
      prePortQuotationStatus: '头程报价状态',
      trunkLineQuotationStatus: '干线报价状态',
      lastMileQuotationStatus: '尾程报价状态',
      validPeriod: '有效期',
      submitDate: '报价时间',
      seaEq: '箱型箱量',
      cargoReadyTime: '货好时间',
      palletNature: '货盘性质',
      carrierId: '船公司',
      directTransit: '直达/中转',
      routeId: '航线',
      loadingPortId: '起运港',
      dischargingPortId: '卸货港',
      destinationPortId: '目的港',
      cargoType: '货物类型',
      serviceTerm: '服务条款',
      weight: '重量(KGS)',
      cubage: '体积(CBM)',
      etd: 'ETD',
      eta: 'ETA',
      clientType: '委托单位类型',
      clientTitle: '委托单位名称',
      remarks: '备注',
      createdBy: '创建人',
      dateCreated: '创建时间',
      modifiedBy: '修改人',
      dateModified: '修改时间',
      actions: '操作'
    },

    // 操作按钮
    actions: {
      view: '查看',
      detail: '详情',
      edit: '编辑',
      submit: '提交',
      revoke: '撤回',
      delete: '删除',
      more: '更多',
      copy: '复制',
      importRate: '导入运价',
      viewRate: '查看运价',
      viewLater: '稍后查看'
    },

    // 确认对话框
    confirmDialog: {
      submitTitle: '确认提交',
      submitContent: '确定要提交报价 "{quotationNo}" 吗？',
      submitOk: '确定提交',
      submitCancel: '取消',
      revokeTitle: '确认撤回',
      revokeContent: '确定要将报价 "{quotationNo}" 撤回为草稿状态吗？',
      revokeOk: '确认撤回',
      revokeCancel: '取消',
      deleteTitle: '确认删除',
      deleteContent: '确定要删除报价 "{quotationNo}" 吗？',
      batchDeleteTitle: '批量删除确认',
      batchDeleteContent: '确定要删除选中的 {count} 条记录吗？'
    },

    // 消息提示
    messages: {
      dataLoadFailed: '加载报价数据失败',
      selectRecordsFirst: '请先选择要删除的记录',
      noDataToExport: '没有可导出的数据',
      exportSuccess: '成功导出 {count} 条记录为 {type} 格式',
      exportFailed: '导出 {type} 格式失败，请稍后重试',
      submitSuccess: '报价提交成功',
      submitFailed: '提交失败，请稍后重试',
      revokeSuccess: '报价已撤回为草稿状态',
      revokeFailed: '撤回失败，请稍后重试',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      copySuccess: '复制成功',
      copyFailed: '复制失败，请稍后重试',
      batchDeleteSuccess: '批量删除成功',
      batchDeleteFailed: '批量删除失败',
      alreadyDraft: '报价已是草稿状态，无需撤回',
      onlySubmittedCanRevoke: '只有已提交的报价才能撤回为草稿',
      invalidStatusForAction: '无效的报价状态',
      cannotDeleteRecords: '已提交报价或者由询价自动创建的报价无法删除，请检查选中记录',
      inquiryNotFound: '询价记录不存在',
      viewInquiryFailed: '查看询价失败',
      importRateSuccess: '导入成功',
      importRateSuccessDesc: '已成功创建运价草稿，可前往海运整箱运价维护中查看和编辑。',
      importRateSuccessDescShort: '报价数据已写入运价维护模块，附加费已同步至附加费管理',
      markupAutoMatching: '加价规则匹配中，销售卖价将自动计算...',
      importRateFailed: '导入运价失败，请检查报价数据是否完整',
      importCancelSuccess: '已取消导入并清理数据',
      importCancelFailed: '取消导入失败',
      surchargeConflictModal: {
        title: '附加费费用判重提示',
        message: '以下费用在现有运价中已存在且金额不同，是否确认覆盖？',
        alert: '检测到以下附加费费用在附加费管理中已存在，将按规则自动处理：',
        columns: {
          surchargeType: '附加费类型',
          feeName: '费用名称',
          oldValue: '原单价',
          newValue: '新单价（报价）',
          actionType: '处理方式'
        },
        actionTypes: {
          overwrite: '覆盖更新',
          new: '新增写入'
        },
        footerNote: {
          line1: '· 已存在的费用行：以报价中的价格覆盖更新',
          line2: '· 新增的费用行：直接写入附加费管理模块',
          line3: '· 删除的费用行：附加费模块保持不变，需人工处理'
        },
        actions: {
          confirmImport: '确认导入'
        }
      }
    },

    // 自定义表格弹窗
    customTableModal: {
      title: '自定义表格字段',
      description: '选择要显示的表格字段',
      resetButton: '重置'
    },

    // 导出
    export: {
      filename: '报价数据'
    }
  },

  // 报价详情页
  quotationDetail: {
    // 页面标题
    pageTitle: {
      create: '新增报价',
      edit: '报价详情',
      view: '报价详情',
      loading: '加载中...'
    },

    // 表单章节
    sections: {
      basicInfo: '基本信息',
      cargoInfo: '货物信息',
      loadingPoint: '装箱门点',
      deliveryAddress: '尾程送货地址',
      containerInfo: '箱型箱量',
      fclPrice: '干线报价',
      prePortPrice: '港前报价',
      lastMilePrice: '尾程报价',
      priceDetail: '运价明细',
      trunkLinePrice: '干线运价',
      addTrunkLinePrice: '新增干线运价',
      addPrePortPrice: '新增港前运价',
      addLastMilePrice: '新增尾程运价',
      rejectQuote: '拒绝报价',
      rejectReason: '请输入拒绝原因',
      feeDetail: '费用明细',
      nonContainerFeeItem: '非箱型计费条目',
      containerFeeItem: '箱型计费条目',
      addNonContainerFeeItem: '新增非箱型计费条目',
      addContainerFeeItem: '新增箱型计费条目'
    },

    // 复选框选项
    checkboxes: {
      prePortPrice: '港前价格',
      trunkLinePrice: '干线价格',
      lastMilePrice: '尾程价格'
    },

    // 操作按钮
    actions: {
      saveDraft: '保存草稿',
      exportQuotation: '导出报价',
      submit: '直接提交',
      cancel: '取消',
      back: '返回',
      delete: '删除',
      confirmReject: '确认拒绝',
      confirmQuote: '确认报价',
      revokeQuote: '撤回报价',
      aiRecognition: 'AI识别',
      addContainerType: '添加箱型',
      bookingNow: '立即订舱'
    },

    // 临时加价（仅前端显示,不落库)
    tempMarkup: {
      action: '临时加价',
      modalTitle: '设置临时加价',
      feeItem: '费用项目',
      boxType: '箱型',
      originalPrice: '原始价格',
      amountLabel: '临时加价幅度（可输入负数进行减价）',
      amountPlaceholder: '请输入加价幅度',
      tipsSignRule: '提示：输入正数为加价，输入负数为减价',
      adjustedPrice: '调整后价格',
      importantNotes: '重要说明：',
      note1: '临时加价仅用于报价参考，不影响原始运价数据',
      note2: '调整后的价格将在表格中以"原价±加价"的形式显示',
      note3: '可随时修改或清除临时加价设置',
      saveSuccess: '临时加价设置成功',
      saveFailed: '临时加价保存失败',
      clearSuccess: '临时加价已清除',
      clearFailed: '临时加价清除失败'
    },

    // 基本信息字段
    basicInfo: {
      quotationNo: '报价编号',
      inquiryNo: '询价编号',
      quoterId: '报价人',
      inquiryCreatedBy: '询价人',
      inquirySubmitDate: '询价时间',
      submitDate: '报价时间',
      palletNature: '货盘性质',
      cargoReadyTime: '货好时间',
      client: '委托单位',
      detailAddress: '详细地址',
      inquiryEnterprise: '询价企业'
    },

    // 货物信息字段
    cargoInfo: {
      directTransit: '直达/中转',
      route: '航线',
      loadingPort: '起运港',
      destinationPort: '目的港',
      dischargingPort: '卸货港',
      transitPort1: '中转港(1st)',
      transitPort2: '中转港(2nd)',
      transitPort3: '中转港(3rd)',
      quantity: '件数',
      weight: '重量',
      dimensions: '尺寸',
      containerRequirement: '用箱要求',
      transportTerms: '运输条款',
      cargoValue: '货值',
      cargoValueCurrency: '货值币种',
      carrier: '船公司',
      routeCode: '航线代码',
      vessel: '船名',
      voyage: '航次',
      sailingSchedule: '开航班期',
      priceValidity: '价格有效期',
      freeTime: '免箱期',
      direct: '直达',
      transit: '中转',
      transitPort: '中转港',
      remarks: '备注'
    },

    // 提示文本
    tips: {
      autoUppercase: '英文字母自动转大写'
    },

    // 装箱门点字段
    loadingPoint: {
      selectArea: '选择装箱门点区域',
      province: '省份',
      city: '城市',
      district: '区/县',
      street: '街道/村镇',
      detailAddress: '详细地址',
      administrativeDivision: '行政区划',
      detailedLocation: '详细定位'
    },

    // 尾程送货地址字段
    deliveryAddress: {
      addressInfo: '配送地址信息',
      addressType: '配送地址类型',
      postalCodeAndCountry: '邮编和国家',
      country: '请选择国家',
      postalCode: '请输入或选择邮编',
      provinceCity: '省市区',
      province: '省份',
      city: '城市',
      district: '区/县',
      detailAddress: '详细地址',
      amazonWarehouse: '亚马逊仓库选择',
      ecangWarehouse: '易仓仓库选择',
      thirdPartyAddress: '第三方地址'
    },

    // 箱型箱量字段
    containerInfo: {
      containerType: '箱型',
      quantity: '数量',
      containerTypeAndQuantity: '箱型箱量：',
      rfTemperatureRequirement: '温度要求',
      rfVentilationRequirement: '通风要求',
      temperatureRange: '请输入温度范围，如：-20 至 30',
      temperatureStart: '起始温度',
      temperatureEnd: '结束温度',
      ventilationDoor: '通风门',
      ventilationOpen: '开',
      ventilationClose: '关',
      ventilationVolume: '风量',
      ventilationVolumeUnit: 'CBM/H',
      ventilationVolumePlaceholder: '请输入风量',
      temperatureUnit: '℃',
      temperatureTo: '至'
    },

    // 占位符文本
    placeholders: {
      autoGenerate: '自动生成',
      selectPalletNature: '请选择货盘性质',
      selectCargoReadyTimeRange: '请选择货好时间区间',
      selectCargoReadyDate: '请选择货好日期',
      selectOption: '请选择',
      selectClientType: '请选择客户类型',
      selectClient: '请选择客户',
      enterInputQuantity: '请输入件数',
      inputServiceTerm: '请输入服务条款',
      inputClientTitle: '请输入客户抬头',
      selectRoute: '请选择航线',
      selectLoadingPort: '请选择起运港',
      selectDestinationPort: '请选择目的港',
      selectDischargingPort: '请选择卸货港',
      selectTransitPort1: '请选择第一中转港',
      selectTransitPort2: '请选择第二中转港',
      selectTransitPort3: '请选择第三中转港',
      // ... (省略部分，已确认内容一致)
      inputWeight: '请输入重量',
      inputDimensions: '请输入尺寸',
      selectContainerRequirement: '请选择用箱要求',
      selectTransportTerms: '请选择运输条款',
      inputCargoValue: '请输入货值',
      selectCargoValueCurrency: '请选择币种',
      selectCarrier: '请选择船公司',
      inputRemarks: '请输入备注信息',
      province: '省份',
      city: '城市',
      district: '区/县',
      street: '街道/村镇',
      inputDetailAddress: '请填入详细地址',
      selectCountry: '请选择国家',
      inputPostalCode: '请输入或选择邮编',
      inputDeliveryAddress: '请填入详细地址',
      selectAmazonWarehouse: '请选择亚马逊仓库',
      selectEcangWarehouse: '请选择易仓仓库',
      selectContainerType: '请选择箱型',
      inputQuantity: '数量',
      inputLoadingPointAddress: '请填入装箱门点地址',
      inputDeliveryAddressText: '请填入尾程送货地址',
      noFclPrices: '暂无干线运价方案',
      noPrePortPrices: '暂无港前运价方案',
      noLastMilePrices: '暂无尾程运价方案',
      quotePending: '待报价',
      quoteRejected: '拒绝报价',
      rejectReason: '请输入拒绝报价的原因...',
      rejectReminder: '注意：拒绝报价后，此报价将无法再次编辑。',
      noFeeDetail: '暂无费用明细，请添加计费条目',
      noPriceDetail: '暂无运价详情，请点击上方按钮添加',
      selectValidPeriod: '请选择有效期',
      selectBeginDate: '请选择开始日期',
      selectEndDate: '请选择结束日期',
      selectDirectFlag: '请选择直达/中转',
      inputVoyageDays: '请输入航程(天)',
      inputDetentionFreeDays: '请输入免用箱(天)',
      inputDemurrageFreeDays: '请输入免堆存(天)',
      selectFeeName: '请选择费用名称',
      autoFill: '自动填充',
      inputPrice: '请输入价格',
      inputUnitRate: '请输入单价',
      selectBillingUnit: '请选择计费单位',
      selectPriceMethod: '请选择运价类型',
      selectMeasureMethod: '请选择计费方式',
      inputSupplier: '请输入供应商',
      inputAgentName: '请输入代理名称',
      selectBranchLine: '请选择支线类型',
      selectSeaRail: '请选择海铁类型',
      inputRouteCode: '请输入航线代码',
      inputVessel: '请输入船名',
      inputVoyageNo: '请输入航次',
      inputVoyage: '请输入有效航程',
      inputFreeTime: '请输入免箱期天数',
      selectTransitPort: '请选择中转港'
    },

    // 单位和后缀
    units: {
      kilogram: 'KGS'
    },

    // AI识别弹窗
    aiModal: {
      loadingPointTitle: 'AI智能识别地址',
      deliveryTitle: 'AI智能识别地址',
      loadingPointDesc: '请将地址信息粘贴到下方文本框中：',
      deliveryDesc: '请将美国地址信息粘贴到下方文本框中：',
      loadingPointTip: '提示：系统将自动解析省市区街道信息，详细地址将填入详细地址栏',
      deliveryRules: '识别规则：',
      deliveryRule1: '如包含亚马逊仓库代码(ONT8/BFI4等)，将自动设置为亚马逊仓库类型',
      deliveryRule2: '如包含易仓代码(LAX203/ATL205等)，将自动设置为易仓类型',
      deliveryRule3: '其他情况将设置为第三方地址，并解析地址和邮编',
      recognize: '识别',
      cancel: '取消'
    },

    // 下拉选项
    options: {
      alibaba: '阿里巴巴集团',
      jd: '京东物流有限公司',
      huawei: '华为技术有限公司',
      xiaomi: '小米科技有限公司',
      haier: '海尔集团公司',
      baosteel: '宝钢集团有限公司',
      cmg: '招商局集团',
      cosco: '中远海运集团'
    },

    // 消息提示
    messages: {
      saveDraftSuccess: '草稿保存成功',
      updateSuccess: '报价更新成功',
      submitSuccess: '报价提交成功',
      saveFailed: '保存失败',
      submitFailed: '提交失败',
      exportPending: '导出运价功能开发中...',
      addressRecognitionSuccess: '地址识别成功',
      inputAddressFirst: '请输入地址信息',
      confirmSubmit: '确认提交报价？',
      confirm: '确定',
      cancel: '取消',
      loading: '加载中...',
      noData: '无数据',
      copySuccess: '文本已复制到剪贴板',
      copyFailed: '复制失败，请手动复制',
      noAvailablePrices: '未找到可用的报价信息，请添加报价并选择所需条目。',
      selectQuotedPriceFirst: '请先选择一个已报价的运价',
      rejectQuoteSuccess: '已拒绝报价',
      rejectQuoteFailed: '拒绝报价失败',
      rejectReasonEmpty: '拒绝原因不能为空',
      failedToGetQuotationText: '无法获取报价文本内容',
      noFeeDataForTrial: '暂无费用数据，无法进行费用试算',
      feeItemNotFound: '未找到对应的费用项，请刷新页面重试',
      bookNowFailed: '确认订舱失败',
      loadTemplateFailed: '加载模板失败',
      openTemplateViewReportFailed: '打开模板查看报表失败',
      quotationAllDisabled: '干线价格、港前价格和尾程价格至少要开启一个',
      confirmQuoteSuccess: '确认报价成功',
      confirmQuoteFailed: '确认报价失败',
      revokeQuoteSuccess: '撤回报价成功',
      revokeQuoteFailed: '撤回报价失败',
      confirmRevoke: '确认撤回',
      confirmRevokeContent: '确定要撤回该段报价吗？撤回后该段将回到待报价状态。',
      cannotRevokeAfterOrder: '该报价已转为订单，无法撤回',
      noPriceWarning: '请先添加运价方案',
      feeRefactorInProgress: '费用明细加载中...',
      invalidVoyage: '请输入有效航程',
      etaBeforeEtd: '预计到港时间不能早于预计开航时间',
      feeNameRequired: '请完整填写费用名称'
    },

    // 验证消息
    validation: {
      transshipmentPortRequired: '选择中转时，中转港不能为空',
      oceanPriceRequired: '请完整填写所有箱型的基础海运费价格',
      oceanCurrencyRequired: '请选择海运费币种',
      surchargePriceRequired: '请完整填写费用项【{name}】所有箱型的价格',
      surchargeUnitPriceRequired: '请完整填写费用项【{name}】的单价',
      surchargeCurrencyRequired: '请选择费用项【{name}】的币种',
      priceValidityRequired: '请选择价格有效期',
      clientRequired: '请选择委托单位',
      salesBranchRequired: '请选择销售分公司'
    },

    // 费用分组相关
    oceanFreight: '海运费',
    perContainerPrice: '单柜价格',
    originCharges: '起运港费用',
    destCharges: '目的港费用',
    potentialCharges: '潜在费用',
    potentialChargesTip: '可能会发生的费用，暂不计入总价',
    addOceanSurcharge: '添加海运附加费',
    addOriginCharge: '添加起运港费用',
    addDestCharge: '添加目的港费用',
    addPotentialCharge: '添加潜在费用',
    prepaid: '预付',
    collect: '到付',
    perContainer: '按箱',
    perBill: '按票',
    containerType: '箱型',

    // 导出运价弹窗
    exportQuotationModal: {
      title: '导出报价',
      containerTypeAndQuantity: '箱型箱量',
      copyQuotationText: '复制快捷报价文本',
      printQuotation: '打印报价单文件',
      printPending: '打印功能开发中'
    },

    // 快捷报价文本弹窗
    quotationTextModal: {
      title: '快捷报价文本',
      description: '以下是根据您选择的箱型箱量生成的报价文本，您可以复制后发送给客户：',
      placeholder: '请输入报价文本',
      close: '关闭',
      copyText: '复制文本'
    },

    // 报价文本内容
    quotationText: {
      title: '【询价报价单】',
      inquiryNo: '询价编号: ',
      inquiryType: '询价类型: ',
      fcl: '整箱',
      prePort: '港前',
      lastMile: '尾程',
      inquirer: '询价人: ',
      containerTypeAndQuantity: '箱型箱量: ',
      routeInfo: '航线信息: ',
      loadingPort: '起运港: ',
      destinationPort: '目的港: ',
      carrier: '船公司: ',
      directTransit: '直达/中转: ',
      priceDetails: '价格明细: ',
      trunkLineFee: '干线费用: ',
      prePortFee: '港前费用: ',
      lastMileFee: '尾程费用: ',
      feeCalculation: '费用计算: ',
      trunkLine: '干线: ',
      cargoReadyTime: '货好时间: ',
      client: '委托单位: ',
      remarks: '备注: ',
      priceDisclaimer: '※ 以上价格仅供参考，实际价格以正式合同为准',
      contactInfo: '※ 如有任何疑问，请联系我们的客服团队',
      notSpecified: '不指定',
      containerCharges: '按箱计费: ',
      otherCharges: '非按箱计费: '
    },

    // 报价显示标签
    priceDisplay: {
      priceNo: '运价编号',
      carrierName: '船公司',
      validPeriod: '有效期',
      directTransit: '直达/中转',
      direct: '直达',
      transit: '中转',
      voyageDays: '航程',
      days: '天',
      detentionFreeDays: '免用箱期',
      demurrageFreeDays: '免堆存期',
      containerCharges: '按箱计费',
      otherCharges: '非按箱计费',
      supplier: '供应商',
      priceMethod: '运价类型',
      agentName: '代理名称'
    },

    // 邮编相关
    zipCode: {
      loading: '加载中...',
      loadProvincesFailed: '加载省份失败',
      loadCitiesFailed: '加载城市失败',
      loadDistrictsFailed: '加载区县失败',
      loadStreetsFailed: '加载街道失败',
      loadZipCodesFailed: '加载邮编失败',
      zipCodeQueryFailed: '邮编查询失败',
      zipCodeLoadSuccess: '中国邮编加载成功',
      loadContainerTypesFailed: '加载集装箱类型数据失败',
      containerTypesLoadSuccess: '集装箱类型数据加载成功'
    },

    // 表格列
    columns: {
      feeName: '费用名称',
      currency: '币种',
      unitRate: '单价',
      measure: '单位',
      remarks: '备注',
      actions: '操作',
      voyageDays: '航程(天)',
      detentionFreeDays: '免用箱(天)',
      demurrageFreeDays: '免堆存(天)'
    },

    // 供应商报价详情专用 (匹配模板路径)
    supplierQuotationDetail: {
      voyageInfo: '航程信息',
      supplierRemarks: '供应商备注',
      feeDetails: '费用明细',
      oceanFreight: '海运费',
      perContainerPrice: '单柜价格',
      originCharges: '起运港费用',
      destCharges: '目的港费用',
      potentialCharges: '潜在费用',
      potentialChargesTip: '可能会发生的费用，暂不计入总价',
      addOceanSurcharge: '添加海运附加费',
      addOriginCharge: '添加起运港费用',
      addDestCharge: '添加目的港费用',
      addPotentialCharge: '添加潜在费用',
      prepaid: '预付',
      collect: '到付',
      perContainer: '按箱',
      perBill: '按票',
      containerType: '箱型',
      unitPrice: '单价',
      quantity: '数量',
      unit: '单位',
      amount: '金额',
      currency: '币种',
      project: '项目',
      remarks: '备注',
      addItem: '新增条目',
      feeType: '费用类别',
      feeTypes: {
        0: '基础海运费',
        1: '海运附加费',
        2: '起运港费用',
        3: '目的港费用',
        4: '潜在费用'
      },
      currentVersion: '当前版本',
      noConsultationRecords: '暂无磋商记录',
      changeContent: '变更内容',
      consultationRemarks: '磋商备注',
      consultationHistory: '磋商记录',
      quotationDetail: '报价明细',
      confirmConsultation: '磋商完成',
      cancel: '取消',
      save: '保存',
      submit: '提交报价',
      edit: '编辑'
    }
  }
}
